import { Component, ViewChild, OnDestroy } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { SearchableEntityDataEditorService } from '../../../../../services/searchable-entity/searchable-entity-data-editor.service';
import { PropertyChangeEvent, MANUAL_EDIT } from '../../../../../models/property-change-event';
import { GridViewKeyEventHandlerService } from '../../../../../services/grid-view-key-event-handler.service';
import { NavigationService } from '../../../../../../core/navigation.service';
import { DatePickerConfigService } from '../../../../../components/datepicker/datepicker-config.service';
import { COMMONPROPERTIES } from '../../../../../models/common-fields';
import { LOTTABLE_FIELDS } from 'app/shared/models/lottable-fields.constants';
import { TABLE_NAME } from 'app/constants';

@Component({
  selector: 'lfwms-basic-cell-editor',
  templateUrl: './basic-cell-editor.component.html',
  styleUrls: ['./basic-cell-editor.component.css']
})
export class BasicCellEditorComponent implements ICellEditorAngularComp, OnDestroy {

  public params: any;
  public isLoading = true;
  public isDropup = false;
  public offset = 0;
  // scrollHeight for dropdowns is half of grid height.
  public scrollHeight = '150px';
  public templateId = 0;
  public propertyName: string;
  public tableEditor: SearchableEntityDataEditorService;
  public keyEventHandler: GridViewKeyEventHandlerService;
  public currentRow: any;
  public dateFormat: string;
  public dateTimeFormat: string;
  public noOptionsDefault = 'No Options';
  public SHIPMENT_TD = 'sodetailtd';
  private isSanitizeEnable: boolean = true;
  // Store reference to event listener for proper cleanup
  private focusEventListener: (() => void) | null = null;

  @ViewChild('primeFocus')
  private primeFocus;

  private setPrimeFocus() {
    if (this.templateId === 1 || this.templateId === 11|| this.templateId === 9) {
      this.primeFocus.nativeElement.focus();
    } else if ((this.templateId === 3) || (this.templateId === 4) ) {
      this.primeFocus.setFocus();
    } else if (this.templateId === 2) {
      this.primeFocus.setFocusOnCell();
    }
    //LFWM-4125- filterlottable-6, lottable-3 and lottable-7 dropdown options based on sku- udf01 val
    //code will execute on expanding the dropdown option-- makes the dropdwn functioning bit slow
    if (this.templateId == 12) {
      //if (this.params.context.componentParent.searchParams.tableId === "asndetailtd") {
        // if (this.currentRow.cells && this.currentRow.cells.lottable06Label && this.params.cellMetaData.elementId == "lottable06") {
        //   const filterVal = this.currentRow.cells.lottable06Label.cVal;
        //   this.params.value.cOptions = this.getDropdownValuesBasedOnSku(this.params.cellMetaData.values, this.params, filterVal);
        // }
        // if (this.currentRow.cells && this.currentRow.cells.lottable03Label && this.params.cellMetaData.elementId == "lottable03") {
        //   const filterVal = this.currentRow.cells.lottable03Label.cVal;
        //   this.params.value.cOptions = this.getDropdownValuesBasedOnSku(this.params.cellMetaData.values, this.params, filterVal);
        // }
        // if (this.currentRow.cells && this.currentRow.cells.lottable07Label && this.params.cellMetaData.elementId == "lottable07") {
        //   const filterVal = this.currentRow.cells.lottable07Label.cVal;
        //   this.params.value.cOptions = this.getDropdownValuesBasedOnSku(this.params.cellMetaData.values, this.params, filterVal);
        // }
      //}
    }
  }

  constructor(protected navService: NavigationService, protected dateConfigService: DatePickerConfigService) {
  }

  // ag-Grid Specific Methods -->>

  public agInit(params: any): void {
    this.params = params;
    this.propertyName = params.cellMetaData.propertyName;
    this.tableEditor = params.context.componentParent.tableEditor;
    this.keyEventHandler = params.context.componentParent.keyEventHandler;
    this.currentRow = params.context.componentParent.pageRows[params.rowIndex];
    //LFWM-4125-- adding lottablelabelcolumn from frontend side as from backend it was not possible
    if (params.context.componentParent.searchParams.tableId == this.SHIPMENT_TD) {
      LOTTABLE_FIELDS.forEach((element) => {
        if (!this.currentRow.cells[element.label]) {
          const obj = { 'cName': element.label, 'cVal': '' };
          this.currentRow.cells[element.label] = obj;
        }
      });
    }
    if (params.context.componentParent.searchParams.tableId == TABLE_NAME.MAINTAIN_MSG_TD) {
      this.isSanitizeEnable = false;
    }
    switch (params.cellMetaData.type) {
      case 'TEXTFIELD': {
        if (params.cellMetaData.displayType === 'EL' || params.cellMetaData.displayType === 'L' ||
            params.cellMetaData.displayType === 'EA') {
          this.templateId = 2;
        } else {
          this.templateId = 1;
        }
        break;
      }
      case 'DROPDOWN':
      case 'EDITABLEDROPDOWN': {
        const pageDef = this.params.context.componentParent.pageDefinition;
        const isLastPage: boolean = pageDef.pageNumber * pageDef.pageSize >= pageDef.recordCount;
        const rowsInLastPage = pageDef.recordCount % pageDef.pageSize === 0 ? pageDef.pageSize : pageDef.recordCount % pageDef.pageSize;
        const rowsInCurrentPage = isLastPage ? rowsInLastPage : pageDef.pageSize;
        const indexFromLastRow: number = rowsInCurrentPage - this.params.rowIndex;
        // const maxVisibleNoOfRowsInScroll = 10;
        // set dropup for last 5rows if records displayed more than 5. else from 6th row.
        this.isDropup = this.params.rowIndex >= 5 && (indexFromLastRow <= 5);
        if (params.cellMetaData.type === 'DROPDOWN') {
          // LFWM-3034-dropdown values of the reasonCode and to_Channel fields should be filtered according to the storerkey.
          // spl case :- screen having only search table and storerkey can be different for each row.
          // implementing only for channel Inventory Transfer screen.
          // storing the filtered values inside cOptions(not changing the metadata).
          if (params.context.componentParent.searchParams.tableId === 'chanlinvtrsfrtd' && params.node.data['storerKey'].cVal) {
            params.value.cOptions = this.getDropdownValuesBasedOnStorer(params.cellMetaData.values, this.params);
          }
          this.templateId = 3;
        } else if (params.cellMetaData.type === 'EDITABLEDROPDOWN') {
          
          //LFWM-4125- filter lottable-6, lottable-3 and lottable-7 dropdown options based on sku- udf01 val
          //these dropdwons will populate on focus to the dropdwon column for first time
            params.value.cOrigOptions = params.cellMetaData.values; 
          if (params.context.componentParent.searchParams.tableId == this.SHIPMENT_TD) {
            this.setLottableLabelAndFilter(params);
          }
          else {
            this.checkLottableValues(this.currentRow, params);
          }
          
          // [LFWM-2114] - adding one more templaeId for editable dropdown
          this.templateId = 12;
          this.noOptionsDefault = '';
        }
        break;
      }
      case 'DATE':
      case 'DATETIME': {
        this.dateFormat = this.dateConfigService.defaultDateDisplayFormat;
        this.dateTimeFormat = `${this.dateConfigService.defaultDateDisplayFormat}  ${this.dateConfigService.defaultTimeDisplayFormat}`;
        const maxVisibleNoOfRowsInScroll = 10;
        if (this.params.rowIndex > this.params.context.componentParent.pageDefinition.pageSize - 2) {
          this.isDropup = true; // dropup for last row
        } else if (this.params.rowIndex >= 1) {
          // calculate offset to show sideways for other rows except row#1
          // indexAfterModulo will have 0-9 (maxVisibleNoOfRowsInScroll=10)
          const indexAfterModulo =
            this.params.rowIndex < maxVisibleNoOfRowsInScroll ?
              this.params.rowIndex : (this.params.rowIndex % maxVisibleNoOfRowsInScroll);
          this.offset = 10 - (indexAfterModulo * 30);
          this.isDropup = undefined;
        }
        if (this.isDropup) {
          this.offset = -280;
        }
        if (params.cellMetaData.type === 'DATE') {
          this.templateId = 4;
        } else if (params.cellMetaData.type === 'DATETIME') {
          this.templateId = 10;
        }
        break;
      }
      case 'CHECKBOX': {
        this.templateId = 5;
        break;
      }
      case 'CHECKBOX_CHR': {
        this.templateId = 5;
        break;
      }
      case 'DROPDOWN_MC': {
        this.templateId = 8;
        break;
      }
      case 'TIME24': {
        this.templateId = 9;
        break;
      }
      case 'DROPDOWN_MS': {
        this.templateId = 11;
        break;
      }
      default: {
        this.templateId = 0;
        break;
      }
    }
    /* params.eGridCell offers the cell editor template as a HTML DOM Element.
      Focus Event Listener is attached to this DOM Element, in order to set focus
       on input element with primeFocus template ID */
    this.focusEventListener = () => this.setPrimeFocus();
    this.params.eGridCell.addEventListener('focus', this.focusEventListener);
    this.isLoading = false;
    this.ensureCellValueShape();
  }
  //LFWM-4125 - Fetch lottableLabel value from commoditytd table for each row SKU value and filter the corresponding lottable dropdowns
  public setLottableLabelAndFilter(params){
    if (params.context.componentParent.searchParams.tableId == this.SHIPMENT_TD) {
      // let lot6AllOptions = [];
      // let lot3AllOptions = [];
      // let lot7AllOptions = [];
      // this.params.context.componentParent.searchService.metadata.columnList.forEach((element) => {
      //   if(element.propertyName == "lottable06"){
      //     lot6AllOptions = element.values;
      //   }
      //   if(element.propertyName == "lottable03"){
      //     lot3AllOptions = element.values;
      //   }
      //   if(element.propertyName == "lottable07"){
      //     lot7AllOptions = element.values;
      //   }
      // })
      const reqParam = {
        "pageInfo":
        {
          "tableId": "commoditytd",
          "pageNo": 1,
          "sortColumn": null,
          "sortOrder": 0,
          "pageSize": 10,
          "fullFetch": true,
          "fetchAllrecords": false,
          "fetchArchiveRecords": false
        },
        "searchCriteria": {
          "conditions": [
            {
              "mandatory": true,
              "clauses": [
                {
                  "column": "storerKey",
                  "operation": "=",
                  "value": params.node.data['storerKey'].cVal,
                  "logicalOperation": null
                }
              ],
              "logicalOperation": "AND"
            },
            {
              "mandatory": false,
              "clauses": [
                {
                  "column": "sku",
                  "operation": "=",
                  "value": this.currentRow.cells.sku.cVal,
                  "logicalOperation": null
                }
              ],
              "logicalOperation": null
            }
          ]
        }
      }
      this.params.context.componentParent.searchService.fetchSku(reqParam).subscribe((res) => {
        if (res && res.pageData.rows && res.pageData.rows.length > 0) {
          let allRes = res.pageData.rows[0].cells.forEach((each) => {
            LOTTABLE_FIELDS.forEach((element) => {
              this.currentRow.cells[element.label].cVal = each.cVal;
              const origOptions = this.currentRow.cells[element.elementId].cOrigOptions;
              const currentVal = this.currentRow.cells[element.label].cVal;
              const storerKey = params.node.data[COMMONPROPERTIES.STORER_KEY].cVal;
              this.currentRow.cells[element.elementId].cOptions = this.getDropdownValuesBasedOnSku(origOptions, this.params,currentVal ,storerKey);            });
          });
        } else {
           LOTTABLE_FIELDS.forEach((element) => {
            const lottableCell = this.currentRow.cells[element.elementId];
            if (lottableCell) {
              const options = lottableCell.cOrigOptions;
              if (options && options.length > 0) {
                this.currentRow.cells[element.elementId].cOptions = this.tableEditor.getValuesBasedOnStorer(options);
              }
            }
          });
        }
      })
    }
  }
  //UWP-30496
  public checkLottableValues(row: any, params: any) {
    if (this.currentRow.cells) {
      LOTTABLE_FIELDS.forEach((element) => {
        const validLottable = row.cells[element.label] && ( params.cellMetaData.propertyName == element.elementId || params.cellMetaData.elementId == element.elementId);
          if (validLottable) {
            const filterVal = row.cells[element.label].cVal;
            const storerKey = row.cells[COMMONPROPERTIES.STORER_KEY].cVal;
            params.value.cOptions = this.getDropdownValuesBasedOnSku(params.cellMetaData.values, this.params, filterVal,storerKey);          }
        }
      );
    }
  }
  public afterGuiAttached() {
    if (this.params.cellStartedEdit) {
      this.setPrimeFocus();
    }
  }

  public refresh(): boolean {
    return true;
  }

  public isPopup(): boolean {
    return false;
  }

  public getValue() {
    /* Note :: params.value is passed as an Object Reference.
      Hence, value getter should return the same and NOT just params.value.cVal */
    return this.params.value;
  }

  public focusIn() {
    // Below change is done to avoid partial focus on multiple cells
    this.params.eGridCell.focus();
  }

  public ngOnDestroy() {
    // Clean up event listeners to prevent memory leaks
    if (this.params && this.params.eGridCell && this.focusEventListener) {
      this.params.eGridCell.removeEventListener('focus', this.focusEventListener);
      this.focusEventListener = null;
    }
    
    // Clean up component references
    this.params = null;
    this.currentRow = null;
    this.tableEditor = null;
    this.keyEventHandler = null;
  }

  // <<-- ag-Grid Specific Methods


  public valueChanged(sourceEvent?: any) {
    let newVal = null;
    let hasValueChanged: boolean;
    if (sourceEvent !== null && sourceEvent !== undefined) {
      if ('string' === typeof sourceEvent) {
        newVal = sourceEvent;
      } else if ('object' === typeof sourceEvent) {
        newVal = sourceEvent['newVal'];
      }
    }
    if ((newVal === null || newVal === undefined) && this.params.cellMetaData.type !== 'DATE' && this.params.cellMetaData.type !== 'DATETIME') {
      newVal = this.params.value.cVal;
    }
    // check if the original value is modified
    this.params.value.isEdited = (this.params.value.cVal !== this.params.value.cValOrig);
    if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
      hasValueChanged = (newVal !== sourceEvent.prevVal);
    } else {
      hasValueChanged = (newVal !== this.params.value.cVal);
    }
    // if the value has changed, send an event and check if the change can be accepted
    this.checkIfHasValueChanged(newVal,hasValueChanged,sourceEvent);
  }

  private checkIfHasValueChanged(newVal: any,hasValueChanged: boolean,sourceEvent?: any){
    if (this.params.value.isEdited || hasValueChanged) {
      // if the value has changed, send an event and check if the change can be accepted
      const event: PropertyChangeEvent = new PropertyChangeEvent();
      event.source = 'table-editor';
      event.type = MANUAL_EDIT;
      event.property = this.params.column.colId;
      event.value = newVal;
      event.previousValue = this.params.value.cValPrev;
      event.origValue = this.params.value.cValOrig;
      event.row = this.params.context.componentParent.pageRows[this.params.rowIndex];
      const acceptChange: boolean = this.tableEditor.propertyValueChanged(event);

      // if the property change is to be rejected, do not set the is edited flag      
      if (acceptChange) {
        // Status flags should be updated in searchService.pagedData.pageRows directly
        this.params.context.componentParent.pageRows[this.params.rowIndex].isEdited = true;
        // if the event is from dropdown the current value is already set in this.cellDataMap[key].cVal
        if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
          // Code changes to fix checkbox selection issue LFWM-1718         
          this.params.value.cValPrev = sourceEvent.prevVal;          
        } else {
          this.params.value.cValPrev = this.params.value.cVal;
          this.params.value.cVal = newVal;
        }
        // [JIRA LFWM-1096 fixes]- Ordered/Received qty should be updated upon UOM change
        // if this is a UOM property, autopopulate the dependant properties
        if (sourceEvent && sourceEvent.type === 'dropdown' && this.params.cellMetaData.displayType === 'EA') {
          this.params.value.cValOldUOM = this.params.value.cValPrev;
          this.tableEditor.autoPopulate(event.row, event.property);
        }
      }
      /* [LFWM-2408] - quick fix - this.params.value.cVal is not updated automatically.
      so that the below code is added after assigning the newVal to this.params.value.cVal.
      need to check whether it is a AG Grid bug */
      this.params.value.isEdited = (this.params.value.cVal !== this.params.value.cValOrig);
      // moving the refresh Cells method to generic editor service
      this.tableEditor.refreshCells(this.params);
      this.navService.preventNavigation = true;
    }
  }

  // JIRA LFWM-927 Fixes - when user tab over from UOM, quantity should be automatically highlighted for user to overwrite the data
  public onTextFocus($event: any) {
    setTimeout(() => {
      $event.target.select();
    }, 5);

  }

  public toggleCheckbox() {
    // Code changes to fix checkbox selection issue LFWM-1718
    const sourceEvent = { type: 'checkbox' };
    sourceEvent['prevVal'] = this.params.value.cVal;
    if (this.params.cellMetaData.dataType === 'String') {
      sourceEvent['newVal'] = (this.params.value.cVal === 'N') ? 'Y' : 'N';
      // LFWM-2959- user screen permission checkbox is integer and the value has to be in string form("0" or "1")
    } else if (this.params.cellMetaData.dataType === 'Integer') {
      sourceEvent['newVal'] = (parseInt(this.params.value.cVal, 10) === 0) ? '1' : '0';
    }
    this.valueChanged(sourceEvent);
  }

  public openLookup(row: any, property: string) {
    this.params.context.componentParent.tableEditor.openLookup(row, property);
  }

  public openMultiColumnPopup(row: any, property: string) {
    this.params.context.componentParent.tableEditor.openMultiColumnPopup(row, property, this.primeFocus);
  }

  public setFocusedCell(row: any, property: any) {
    this.params.context.componentParent.searchService.getPagedData().focusedRow = row;
    this.params.context.componentParent.searchService.getPagedData().focusedCellId = property;
    this.params.context.componentParent.keyEventHandler.setFocusedCell(row, property);
  }

  // method used for displaying multicolumn dropdown
  public showMultiColumnDropdown(row: any, colProp: any) {
    row.cells[colProp].showMultiColumn = !row.cells[colProp].showMultiColumn;
  }

  // method  used to handle multi column click
  public handleMultiColumnClick(row: any, colProp: any, key: any, value: any) {
    const currentVal = row.cells[colProp].cVal;
    if (key === row.cells[colProp].cName || key === 'key') {
      row.cells[colProp].cVal = value;
    } else {
      row.cells[colProp].cVal = currentVal;
    }
    row.cells[colProp]['isEdited'] = true;
    row['isEdited'] = true;
    this.showMultiColumnDropdown(row, colProp);
    this.tableEditor.autoPopulate(row, colProp);
  }

  public onValueChangeInTypeaheadTextBox(event) {
    this.valueChanged(event);
  }
  public toSetFocusFromTypeaheadTextBox(event) {
    this.setFocusedCell(event.row, event.property);
  }
  public editKeyPressListnerInTypeaheadTextBox(event) {
    this.keyEventHandler.editKeyPressListner(event.event, event.currentRow, this.params.cellMetaData);
  }

  public onValueChangeOfTimeComponent(event) {
    this.valueChanged(event);
  }

  //LFWM-4125
  public getDropdownValuesBasedOnSku(originalOptions: any, params: any, filterVal, storerKey?: string){
    let filteredValues: any = [];
   
    if (originalOptions && originalOptions.length > 0) {
       originalOptions.forEach(element => {
        if (params.node.data['sku'] && params.node.data['sku'].cVal && filterVal && element.userDefineValues && element.userDefineValues.udf01) {
          if (filterVal == element.userDefineValues.udf01 && storerKey == element.storerkey) {
            filteredValues.push(element);
          }
        } else if (!filterVal && storerKey == element.storerkey) {
            filteredValues.push(element);
        }
      });
    }
    // If the filteredValues is not empty, - Select - is added as the first value.
    if (filteredValues.length !== 0) {
      filteredValues.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
    }
    if(filteredValues.length == 0)
      filteredValues = originalOptions;
    
    return filteredValues;
  }
  // LFWM-3034- filtering the dropdown valueList based on storer.
  public getDropdownValuesBasedOnStorer(originalOptions: any, params: any){
    let filteredValues: any = [];
    // if the storerKey of the particular row matches with the storerKey of the value in the ValueList of the metadata,
    // that value is pushed to filteredValues List.
    originalOptions.forEach(element => {
      if (element.storerkey && params.node.data['storerKey']) {
        if (params.node.data['storerKey'].cVal &&
          (element.storerkey.toUpperCase() === params.node.data['storerKey'].cVal.trim().toUpperCase())) {
            filteredValues.push(element);
        }
      }
    });
    // If the filteredValues is not empty, - Select - is added as the first value.
    if (params.node.data['storerKey'] && params.node.data['storerKey'].cVal
      && filteredValues) {
      if (filteredValues.length !== 0) {
        filteredValues.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
      }
    }
    // if the filteredValues is empty then the values having empty storerkey or storerkey with null value is pushed into the filteredValues.
    if (filteredValues.length === 0) {
      originalOptions.forEach(element => {
        if (element.storerkey === '' || element.storerkey === null) {
          filteredValues.push(element);
        }
      });
    }
    // if the filteredValues has only - select - then filteredValues is made empty. 
    if (filteredValues.length === 1 && filteredValues[0].key === '' &&
    filteredValues[0].value.toLowerCase() === '- select -') {
      filteredValues = [];
    }
    return filteredValues;
  }

  // UWP-53063 - Cannot read properties of undefined (reading 'isValueInvalid')
  private ensureCellValueShape() {
    if(this.params.value === undefined) {
      this.params.value = { cVal: '', isValueInvalid: false };
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/results/result-data-table/editors/basic-cell-editor/basic-cell-editor.component.ts